// src/app/auth.interceptor.ts
import {Injectable} from '@angular/core';
import {HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse} from '@angular/common/http';
import {Observable, catchError, switchMap, throwError} from 'rxjs';
import {AuthService} from '../services/auth.service';
import {Router} from "@angular/router";
import {environment} from "../../../environments/environment";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService, private router: Router) {}

  /*
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Hole die aktuell im Browser sichtbare URL
    const currentUrl = this.router.url;

    // Prüfe, ob die URL 'admin' oder 'user-profile' enthält
    if (currentUrl.includes('admin') || currentUrl.includes('user-profile')) {
      // Vermeide, den Token bei Token-Refresh-Requests anzuhängen
      if (!req.url.includes('/auth/api/token/refresh/')) {
        const token = this.authService.getAccessToken();
        req = this.addToken(req, token);
      }
    }

    return next.handle(req).pipe(
      catchError(error => {
        // Bei 401-Fehlern: Prüfe erneut die aktuelle URL und starte ggf. den Refresh-Prozess
        if (error instanceof HttpErrorResponse && error.status === 401 && (currentUrl.includes('admin') || currentUrl.includes('user-profile'))) {
          return this.handle401Error(req, next);
        } else {
          return throwError(() => error);
        }
      })
    );
  }

   */

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Prüfe, ob der Request an deinen API-Bereich geht und nicht der Refresh-Endpoint ist.
    if (req.url.startsWith(environment.apiUrl) && !req.url.includes('/auth/api/token/refresh/')) {
      const token = this.authService.getAccessToken();
      req = this.addToken(req, token);
    }

    return next.handle(req).pipe(
      catchError(error => {
        // Bei 401-Fehlern den Refresh-Vorgang anstoßen, falls sinnvoll, oder Logout
        if (error instanceof HttpErrorResponse && error.status === 401) {
          return this.handle401Error(req, next);
        } else {
          return throwError(() => error);
        }
      })
    );
  }

  private addToken(req: HttpRequest<any>, token: string | null): HttpRequest<any> {
    if (token) {
      return req.clone({
        setHeaders: {
          'Authorization': `Bearer ${token}`
        }
      });
    }
    return req;
  }

  private handle401Error(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.authService.refreshToken().pipe(
      switchMap((token: any) => {
        return next.handle(this.addToken(req, token.access));
      }),
      catchError((err) => {
        // Bei Fehlern den Logout auslösen
        this.authService.clearTokens();
        return throwError(() => err);
      })
    );
  }
}
